import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Translation extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Translation';
    // Define default properties here
    static instanceDefaults() {
        return {
            language: '',
            key: '',
            text: ''
        }
    }
}
const servicePath = 'translations'
const servicePlugin = makeServicePlugin({
    Model: Translation,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
